import { MessageSquare } from "lucide-react";

export function InboxEmptyState() {
  return (
    <div className="flex h-full w-full flex-col items-center justify-center gap-4 text-muted-foreground">
      <MessageSquare className="h-16 w-16 opacity-20" />
      <p className="text-lg">Selecione uma conversa</p>
      <p className="text-sm">
        Escolha uma conversa no painel esquerdo para visualizar as mensagens
      </p>
    </div>
  );
}
